import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { Services } from './../services-url';

@Injectable({
  providedIn: 'root'
})
export class NewService {

  constructor(
    private http: HttpClient,
  ) { }


  getNews():Observable<any>{
    return this.http.get(Services.news).pipe(
      tap(news => console.info(`fetched news`))
    );
  }

  getNew(token):Observable<any>{
    return this.http.get(`${Services.new}/${token}`).pipe(
      tap(notice => console.info(`fetched new`))
    );
  }

  getRelatedNews():Observable<any>{
    return this.http.get(`${Services.relatedNews}`).pipe(
      tap(notice => console.info(`fetched related new`))
    );
  }
}
